// mobile toggle
const toggle = document.querySelector(".subnav-mobile");
if (toggle) {
    const innerElement = toggle.parentElement.querySelector(".subnav-inner");
    toggle.addEventListener("click", () => {
        if (!toggle.classList.contains("--open")) {
            toggle.classList.add("transit");
            toggle.classList.add("--open");
            innerElement.style.height = `${innerElement.scrollHeight}px`;
        }
        else {
            innerElement.style.height = `${innerElement.scrollHeight}px`;
            toggle.classList.add("transit");
            setTimeout(() => {
                toggle.classList.remove("--open");
                innerElement.style.height = ``;
            }, 0);
        }
    });
    toggle.addEventListener("transitionend", () => {
        // expand
        innerElement.style.height = ``;
        toggle.classList.remove("transit");
    });
}
// set active nav for mobile toggle
//const activeItem = document.querySelector(".subnav .subnav-link.active");
//const currentMobileItem = document.querySelector(".subnav .subnav-mobile-current");
//if (currentMobileItem) {
//    currentMobileItem.textContent = !!activeItem ? activeItem.textContent : "View More";
//}
export default undefined;
